import { Play, Pause, Square, XCircle } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import type { TimerStatus } from '@/shared/stores/timerStore'

interface TimerControlsProps {
  status: TimerStatus
  canStart: boolean
  onStart: () => void
  onPause: () => void
  onResume: () => void
  onStop: () => void
  onCancel: () => void
}

export function TimerControls({
  status,
  canStart,
  onStart,
  onPause,
  onResume,
  onStop,
  onCancel,
}: TimerControlsProps) {
  if (status === 'idle') {
    return (
      <Button
        onClick={onStart}
        disabled={!canStart}
        size="lg"
        className="w-full bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white shadow-md hover:shadow-lg transition-all duration-200"
        data-testid="start-btn"
      >
        <Play className="mr-2 h-5 w-5" />
        Start Timer
      </Button>
    )
  }

  if (status === 'running') {
    return (
      <div className="flex gap-2">
        <Button
          variant="outline"
          onClick={onPause}
          size="lg"
          className="flex-1 border-2 hover:bg-amber-50 hover:border-amber-300 hover:text-amber-700 transition-all duration-200"
          data-testid="pause-btn"
        >
          <Pause className="mr-2 h-4 w-4" />
          Pause
        </Button>
        <Button
          variant="outline"
          onClick={onStop}
          size="lg"
          className="flex-1 border-2 border-green-300 text-green-700 hover:bg-green-50 hover:border-green-500 transition-all duration-200"
          data-testid="stop-btn"
        >
          <Square className="mr-2 h-4 w-4" />
          Stop
        </Button>
        <Button
          variant="outline"
          onClick={onCancel}
          size="lg"
          className="flex-1 border-2 border-red-200 text-red-600 hover:bg-red-50 hover:border-red-400 transition-all duration-200"
          data-testid="cancel-btn"
        >
          <XCircle className="mr-2 h-4 w-4" />
          Cancel
        </Button>
      </div>
    )
  }

  return (
    <div className="flex gap-3">
      <Button
        onClick={onResume}
        size="lg"
        className="flex-1 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white shadow-md transition-all duration-200"
        data-testid="resume-btn"
      >
        <Play className="mr-2 h-4 w-4" />
        Resume
      </Button>
      <Button
        variant="outline"
        onClick={onStop}
        size="lg"
        className="flex-1 border-2 border-red-200 text-red-600 hover:bg-red-50 hover:border-red-400 transition-all duration-200"
        data-testid="stop-btn"
      >
        <Square className="mr-2 h-4 w-4" />
        Stop
      </Button>
    </div>
  )
}

export default TimerControls
